// const baseStyles = 'min-h-[850px] h-fit lg:h-screen lg:min-h-0 lg:max-h-[1280px]'
const baseStyles = 'h-screen min-h-[700px] max-h-[950px] box-border'

// export const parallaxStyle = `w-screen ${baseStyles} bg-cover bg-fixed bg-no-repeat`
export const parallaxStyle = `w-screen ${baseStyles} bg-no-repeat bg-cover`

export const basicStyle = `w-screen ${baseStyles} bg-no-repeat bg-cover`

export const motionStyles = {
  initial: {
    opacity: 0,
    translate: 'none',
    rotate: 'none',
    scale: 'none',
    transform: 'translate3d(0px, 100%, 0px)',
  },
  animate: {
    opacity: 1,
    translate: 'none',
    rotate: 'none',
    scale: 'none',
    transform: 'translate3d(0px, 0%, 0px)',
  },
  transition: {
    type: 'spring',
    bounce: 0,
    duration: 0.7,
  },
}
